<template>
	<div class="square-m-skeleton" aria-hidden="true">
		<section v-for="section in 3" :key="section" class="square-m-skeleton__section">
			<div class="square-m-skeleton__head">
				<span class="square-m-skeleton__title"></span>
				<span class="square-m-skeleton__button"></span>
			</div>
			<div class="square-m-skeleton__grid">
				<div v-for="card in 1" :key="card" class="square-m-skeleton__card">
					<span class="square-m-skeleton__cover"></span>
					<span class="square-m-skeleton__line square-m-skeleton__line--wide"></span>
					<span class="square-m-skeleton__line square-m-skeleton__line--short"></span>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.square-m-skeleton {
	padding: 40px 30px;

	&__section {
		margin-bottom: 42px;
	}

	&__head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	&__title,
	&__button,
	&__cover,
	&__line {
		display: block;
		background: linear-gradient(90deg, #f1f1f1 25%, #fafafa 40%, #f1f1f1 60%);
		background-size: 300% 100%;
		animation: square-m-skeleton-shimmer 1.4s ease-in-out infinite;
	}

	&__title {
		width: 180px;
		height: 40px;
		border-radius: 8px;
	}

	&__button {
		width: 110px;
		height: 42px;
		border-radius: 8px;
	}

	&__grid {
		display: grid;
		grid-template-columns: minmax(0, 1fr);
		gap: 18px;
	}

	&__card {
		padding-bottom: 20px;
		overflow: hidden;
		border: 1px solid #efefef;
		border-radius: 16px;
	}

	&__cover {
		width: 100%;
		aspect-ratio: 16 / 9;
	}

	&__line {
		height: 24px;
		margin: 18px 14px 0;
		border-radius: 5px;

		&--wide {
			width: 75%;
		}

		&--short {
			width: 48%;
			height: 18px;
		}
	}
}

@keyframes square-m-skeleton-shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: 0 0;
	}
}

@media (prefers-reduced-motion: reduce) {
	.square-m-skeleton__title,
	.square-m-skeleton__button,
	.square-m-skeleton__cover,
	.square-m-skeleton__line {
		animation: none;
	}
}
</style>
